export default "__VITE_ASSET__hRH2$KST__"